import getFeatureCounts from 'api/v2/users/getFeatureCounts';
import useQuery from 'hooks/react-query/useQuery';

import { UserCacheKeys } from 'types/cacheKeys.types';
import { getStoredAuthData } from 'utils/auth';

const useFeatureCounts = () =>
  useQuery([UserCacheKeys.FeatureCounts], getFeatureCounts, {
    gcTime: 0,
    staleTime: 0,
    enabled: !!getStoredAuthData('access_token'),
  });

export default useFeatureCounts;
